import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BasicPage } from '@app/model/basic-page.model';
import { DataResponse } from '@app/model/data-response.model';
import { CachedHttpService, HttpService } from 'library-explorer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  constructor(
    private readonly httpService: HttpService,
    private readonly cacheHttpService: CachedHttpService,
  ) { }

  public getMenu(): Observable<DataResponse<BasicPage>> {
    const params = new HttpParams().set('menuName', 'footer');
    return this.cacheHttpService.get<DataResponse<BasicPage>>('menu-items', params, true)
  }
}
